import { render, staticRenderFns } from "./CardTarjaTwitterSaiaJusta.vue?vue&type=template&id=b1af7fe2&scoped=true"
import script from "./CardTarjaTwitterSaiaJusta.vue?vue&type=script&lang=js"
export * from "./CardTarjaTwitterSaiaJusta.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaTwitterSaiaJusta.vue?vue&type=style&index=0&id=b1af7fe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1af7fe2",
  null
  
)

export default component.exports